import { useParams } from 'react-router-dom';
import { useCallback, useMemo, useState } from 'react';
import { useCountryMapping } from 'hooks/useCountryMapping';
import { useCountryAllWarehouseListQuery, useShippingAddressQuery, useShippingSpecialRatesQuery } from 'api';
import { SpecialRate } from './index';

export const useSpecialRates: any = () => {
  const [openModal, setOpenModal] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [dataToEdit, setDataToEdit] = useState<SpecialRate | undefined>();
  const { countryMapping } = useCountryMapping();
  const { id } = useParams() as { id: string };
  const { data: warehouseData = [] } = useCountryAllWarehouseListQuery();
  const { data: specialRates = [] } = useShippingSpecialRatesQuery({ id });
  const { data: { data: shippingAddress = [] } = {} } = useShippingAddressQuery({ id });

  const specialRatesData = useMemo(() => {
    const clonedSpecialRates = structuredClone(specialRates);
    return clonedSpecialRates.map((_item: any) => {
      const country = countryMapping[_item.countryId];
      if (country) {
        _item.countryName = country.commonName;
      }
      const warehouse = warehouseData.find((_warehouse: any) => _warehouse.id === _item.warehouseId);
      if (warehouse) {
        _item.warehouseName = warehouse.name;
      }

      return _item;
    });
  }, [countryMapping, specialRates, warehouseData]);

  const onHandleEdit = useCallback((data: SpecialRate) => {
    setDataToEdit(data);
    setOpenModal(true);
  }, []);
  const onHandleDelete = useCallback((data: SpecialRate) => {
    setDataToEdit(data);
    setIsDeleteModalOpen(true);
  }, []);
  const onDeleteModalClose = useCallback(() => {
    setIsDeleteModalOpen(false);
    setDataToEdit(undefined);
  }, []);
  const onModalStateChange = useCallback(() => {
    setOpenModal((oState) => {
      if (oState) {
        setDataToEdit(undefined);
      }
      return !oState;
    });
  }, []);

  return {
    openModal,
    specialRatesData,
    onModalStateChange,
    onHandleEdit,
    dataToEdit,
    onHandleDelete,
    isDeleteModalOpen,
    onDeleteModalClose,
    addDisabled: !shippingAddress.length,
  };
};
